export default [
  {
    path: "/apps/event",
    name: "apps-event",
    component: () => import("@/views/apps/event-calendar/Calendar.vue"),
  },
  {
    path: "/apps/calendar",
    name: "apps-calendar",
    component: () => import("@/views/apps/academic/Calendar.vue"),
  },
  {
    path: "/event-calendar",
    name: "apps-event-calendar",
    component: () => import("@/views/apps/calendar/Calendar.vue"),
  },
  {
    path: "/device-settings",
    name: "device-settings",
    component: () => import("@/views/myskool/management/deviceSettings.vue"),
  },
  {
    path: "/manage-classes",
    name: "manage-classes",
    component: () => import("@/views/myskool/profiles/classesRedirect.vue"),
  },
  {
    path: "/manage-student",
    name: "manage-studentgrid",
    component: () => import("@/views/myskool/student/grid.vue"),
  },
  {
    path: "/manage-enrolled",
    name: "manage-enrolled",
    component: () => import("@/views/myskool/student/gridEnrolled.vue"),
  },
  {
    path: "/student-registered",
    name: "student-registered",
    component: () => import("@/views/myskool/student/studentRegistered.vue"),
  },
  {
    path: "/student-enrolled",
    name: "student-enrolled",
    component: () => import("@/views/myskool/student/studentEnrolled.vue"),
  },
  {
    path: "/student-transfer",
    name: "student-transfer",
    component: () => import("@/views/myskool/student/studentTransfer.vue"),
  },
  {
    path: "/section-transfer",
    name: "section-transfer",
    component: () => import("@/views/myskool/student/sectionTransfer.vue"),
  },
  {
    path: "/requests",
    name: "leaving-requests",
    component: () => import("@/views/myskool/student/leavingRequests.vue"),
  },
  {
    path: "/leaving-request-print",
    name: "leaving-request-print",
    component: () => import("@/views/myskool/reports/LeavingRequestPrint.vue"),
    meta: {
      layout: "full",
      resource: "Auth",
    },
  },
  {
    path: "/student-leave-requests",
    name: "student-leave-requests",
    component: () => import("@/views/myskool/student/studentLeaveRequest.vue"),
  },
  {
    path: "/student-withdrawal",
    name: "student-withdrawal",
    component: () => import("@/views/myskool/student/withdrawalInbox.vue"),
  },
  {
    path: "/student-withdrawal/new",
    name: "student-withdrawal-form",
    component: () => import("@/views/myskool/student/withdrawalInbox.vue"),
  },
  {
    path: "/student-withdrawal/:id",
    name: "student-withdrawal-detail",
    component: () => import("@/views/myskool/student/withdrawalInbox.vue"),
    props: true,
  },
  {
    path: "/student-retention-history",
    name: "student-retention-history",
    component: () => import("@/views/myskool/student/withdrawalInbox.vue"),
  },
  {
    path: "/student-leave-report-print",
    name: "student-leave-report-print",
    component: () =>
      import("@/views/myskool/student/StudentLeaveReportPrint.vue"),
    meta: {
      layout: "full",
      resource: "Auth",
    },
  },
  {
    path: "/student-info",
    name: "student-info",
    component: () => import("@/views/myskool/student/studentPrint.vue"),
    props: true,
  },
  {
    path: "/student-complaints",
    name: "student-complaints",
    component: () => import("@/views/myskool/student/studentComplaints.vue"),
  },
  {
    path: "/student-category",
    name: "student-category",
    component: () => import("@/views/myskool/student/studentCategory.vue"),
  },
  {
    path: "/student-interview",
    name: "student-interview",
    component: () => import("@/views/myskool/student/studentInterview.vue"),
  },
  {
    path: "/donors",
    name: "donors",
    component: () => import("@/views/myskool/student/donors.vue"),
  },
  {
    path: "/student-documents",
    name: "student-documents",
    component: () => import("@/views/myskool/student/studentDocuments.vue"),
  },
  {
    path: "/manage-branches",
    name: "manage-branches",
    component: () => import("@/views/myskool/schoolinfo/branchcards.vue"),
  },
  {
    path: "/manage-companies",
    name: "manage-companies",
    component: () => import("@/views/myskool/schoolinfo/companyCards.vue"),
  },
  {
    path: "/school-complaints",
    name: "school-complaints",
    component: () => import("@/views/myskool/schoolinfo/schoolComplaints.vue"),
  },
  {
    path: "/complaints",
    name: "complaints",
    component: () => import("@/views/myskool/schoolinfo/complaints.vue"),
  },
  {
    path: "/school-dashboard",
    name: "school-dashboard",
    component: () => import("@/views/myskool/schoolinfo/dashboard.vue"),
  },
  {
    path: "/circulars",
    name: "circulars",
    component: () => import("@/views/myskool/schoolinfo/circulars.vue"),
  },
  {
    path: "/achievements",
    name: "achievements",
    component: () =>
      import("@/views/myskool/schoolinfo/achievementHistory.vue"),
  },
  {
    path: "/academic-documents",
    name: "academic-documents",
    component: () =>
      import("@/views/myskool/schoolinfo/circulars-academics.vue"),
  },
  {
    path: "/manage-clubs",
    name: "manage-clubs",
    component: () => import("@/views/myskool/schoolinfo/clubs.vue"),
  },
  {
    path: "/join-club",
    name: "join-club",
    component: () => import("@/views/myskool/schoolinfo/joinClub.vue"),
    meta: {
      layout: "full",
      resource: "Auth",
      proceed: true,
    },
  },
  {
    path: "/attendance-note",
    name: "attendance-note",
    component: () => import("@/views/myskool/schoolinfo/attendanceNote.vue"),
    meta: {
      layout: "full",
      resource: "Auth",
      proceed: true,
    },
  },
  {
    path: "/birthdays",
    name: "birthdays",
    component: () => import("@/views/myskool/schoolinfo/BirthdayClasswise.vue"),
  },
  {
    path: "/manage-inquiry",
    name: "manage-inquiry",
    component: () => import("@/views/myskool/inquiry/inquiry.vue"),
  },
  {
    path: "/manage-inquiry-new",
    name: "manage-inquiry-new",
    component: () => import("@/views/myskool/inquiry/inquiryNew.vue"),
    props: true,
  },
  {
    path: "/inquiry",
    name: "inquiry",
    component: () => import("@/views/myskool/inquiry/inquiryGridNew.vue"),
  },
  {
    path: "/inquiry-form",
    name: "inquiry-form",
    component: () => import("@/views/myskool/inquiry/inquiryFormNew.vue"),
    props: true,
  },
  {
    path: "/manage-student/:id/:readmit?",
    name: "manage-student",
    component: () => import("@/views/myskool/student/studentFormEntry.vue"),
    props: true,
  },
  {
    path: "/student-coachinggrid",
    name: "student-coachinggrid",
    component: () => import("@/views/myskool/student/gridCoaching.vue"),
  },
  {
    path: "/student-coachinggrid/:id/:readmit?",
    name: "student-coaching",
    component: () => import("@/views/myskool/student/studentCoaching.vue"),
    props: true,
  },
  {
    path: "/student-details/:id",
    name: "student-details",
    component: () => import("@/views/myskool/student/studentDetails.vue"),
  },
  {
    path: "/student",
    name: "student-public",
    component: () => import("@/views/myskool/student/studentPublic.vue"),
    props: true,
  },
  {
    path: "/add-student",
    name: "add-student",
    component: () => import("@/views/myskool/student/addStudent.vue"),
  },
  {
    path: "/manage-ptm",
    name: "manage-ptm",
    component: () => import("@/views/myskool/student/ManagePtm.vue"),
  },
  {
    path: "/signup-classes",
    name: "signup-classes",
    component: () => import("@/views/myskool/student/signupClasses.vue"),
  },
  {
    path: "/manage-addbranch",
    name: "manage-addbranch",
    component: () => import("@/views/myskool/schoolinfo/myschoolinfo.vue"),
  },
  {
    path: "/campus-details/:id?",
    name: "campus-details",
    component: () => import("@/views/myskool/schoolinfo/campusDetails.vue"),
  },
  {
    path: "/manage-fee",
    name: "manage-fee",
    component: () => import("@/views/myskool/feestructure/FeeStructure.vue"),
  },
  {
    path: "/staff-departments",
    name: "staff-departments",
    component: () => import("@/views/myskool/departments/StaffDepartments.vue"),
  },
  {
    path: "/staff-transfer",
    name: "staff-transfer",
    component: () => import("@/views/myskool/staff/staffTransfer.vue"),
  },
  {
    path: "/staff-transfer-history",
    name: "staff-transfer-history",
    component: () => import("@/views/myskool/staff/staffTransferHistory.vue"),
  },
  {
    path: "/manage-staff",
    name: "manage-staffgrid",
    component: () => import("@/views/myskool/staff/staffGrid.vue"),
    meta: {
      resource: "Auth",
    },
  },
  {
    path: "/manage-staff/:id",
    name: "manage-staff",
    component: () => import("@/views/myskool/staff/myStaff.vue"),
    meta: {
      resource: "Auth",
    },
  },
  {
    path: "/staff-details/:id",
    name: "staff-details",
    component: () => import("@/views/myskool/staff/staffDetails.vue"),
  },
  {
    path: "/manage-staff-accounts/:id",
    name: "manage-staff-accounts",
    component: () => import("@/views/myskool/staff/myStaffAccounts.vue"),
  },
  {
    path: "/staff-requests",
    name: "staff-requests",
    component: () => import("@/views/myskool/staff/staffRequests.vue"),
  },
  {
    path: "/leave-requests",
    name: "leave-requests",
    component: () => import("@/views/myskool/staff/leaveRequest.vue"),
  },
  {
    path: "/late-approval",
    name: "late-approval",
    component: () => import("@/views/myskool/staff/LateApproval.vue"),
  },
  {
    path: "/in-house-doctor",
    name: "in-house-doctor",
    component: () => import("@/views/myskool/staff/inHouseDoctor.vue"),
  },
  {
    path: "/health-assessment",
    name: "health-assessment",
    component: () => import("@/views/myskool/staff/HealthAssessment.vue"),
  },
  {
    path: "/exit-interview",
    name: "exit-interview",
    component: () => import("@/views/myskool/staff/exitInterview.vue"),
  },
  {
    path: "/salary-tax-slab",
    name: "salary-tax-slab",
    component: () => import("@/views/myskool/staff/SalaryTaxSlab.vue"),
  },
  {
    path: "/news-feed",
    name: "news-feed",
    component: () => import("@/views/myskool/newsfeed/newsfeed.vue"),
  },
  {
    path: "/teaching-classes/:id",
    name: "teaching-classes",
    component: () => import("@/views/myskool/staff/teacherClasses.vue"),
  },
  {
    path: "/requisition",
    name: "requisition",
    component: () => import("@/views/myskool/staff/requisition.vue"),
  },
  {
    path: "/purchase",
    name: "purchase",
    component: () => import("@/views/myskool/inventory/purchase.vue"),
  },
  {
    path: "/purchase-order",
    name: "purchase-order",
    component: () => import("@/views/myskool/staff/purchaseOrder.vue"),
  },
  {
    path: "/staff-application/:id?",
    name: "staff-application",
    component: () => import("@/views/myskool/staff/staffApplication.vue"),
    props: true,
  },
  {
    path: "/applicants",
    name: "applicants",
    component: () => import("@/views/myskool/staff/allApplications.vue"),
  },
  {
    path: "/staff-performance",
    name: "staff-performance",
    component: () => import("@/views/myskool/staff/performanceCards.vue"),
  },
  {
    path: "/manage-performance/:id",
    name: "manage-performance",
    component: () => import("@/views/myskool/staff/performanceForm.vue"),
  },
  {
    path: "/staff-evaluation",
    name: "staff-evaluation",
    component: () => import("@/views/myskool/staff/staffPerformance.vue"),
  },
  {
    path: "/challan",
    name: "manage-challan",
    component: () => import("@/views/myskool/feestructure/challan.vue"),
  },
  {
    path: "/planner-logs-print",
    name: "planner-logs-print",
    component: () => import("@/views/myskool/reports/PlannerLogsPrint.vue"),
    meta: {
      layout: "full",
      resource: "Auth",
      action: "read",
    },
  },
  {
    path: "/student-ledger-print",
    name: "student-ledger-print",
    component: () => import("@/views/myskool/feestructure/LedgerPrint.vue"),
  },
  {
    path: "/advance-ledger-print",
    name: "advance-ledger-print",
    component: () => import("@/views/myskool/reports/AdvanceLedgerPrint.vue"),
    meta: {
      layout: "full",
      resource: "Auth",
      action: "read",
    },
  },
  {
    path: "/expense-report-print",
    name: "expense-report-print",
    component: () => import("@/views/myskool/reports/ExpenseReportPrint.vue"),
    meta: {
      layout: "full",
      resource: "Auth",
      action: "read",
    },
  },
  {
    path: "/expense-report-beprince-print",
    name: "expense-report-beprince-print",
    component: () =>
      import("@/views/myskool/reports/ExpenseReportBeprincePrint.vue"),
    meta: {
      layout: "full",
      resource: "Auth",
      action: "read",
    },
  },
  {
    path: "/expense-monthly-category-print",
    name: "expense-monthly-category-print",
    component: () =>
      import("@/views/myskool/reports/ExpenseMonthlyCategoryPrint.vue"),
    meta: {
      layout: "full",
      resource: "Auth",
      action: "read",
    },
  },
  {
    path: "/event-calendar-report-print",
    name: "event-calendar-report-print",
    component: () =>
      import("@/views/myskool/reports/EventCalendarReportPrint.vue"),
    meta: {
      layout: "full",
      resource: "Auth",
      action: "read",
    },
  },
  {
    path: "/remaining-leaves-print",
    name: "remaining-leaves-print",
    component: () => import("@/views/myskool/reports/RemainingLeavesPrint.vue"),
    meta: {
      layout: "full",
      resource: "Auth",
      action: "read",
    },
  },
  {
    path: "/staff-loan-advance-report",
    name: "staff-loan-advance-report",
    component: () =>
      import("@/views/myskool/reports/StaffLoanAdvanceReportPrint.vue"),
    meta: {
      layout: "full",
      resource: "Auth",
      action: "read",
    },
  },
  {
    path: "/fee-reminder-print",
    name: "fee-reminder-print",
    component: () => import("@/views/myskool/reports/FeeReminderPrint.vue"),
    meta: {
      layout: "full",
      resource: "Auth",
      action: "read",
    },
  },
  {
    path: "/custom-fee-report-print",
    name: "custom-fee-report-print",
    component: () => import("@/views/myskool/reports/CustomFeeReportPrint.vue"),
    meta: {
      layout: "full",
      resource: "Auth",
      action: "read",
    },
  },

  {
    path: "/cheque-summary-print",
    name: "cheque-summary-print",
    component: () => import("@/views/myskool/reports/ChequeSummaryPrint.vue"),
    meta: {
      layout: "full",
      resource: "Auth",
      action: "read",
    },
  },
  {
    path: "/cheque-book-summary-print",
    name: "cheque-book-summary-print",
    component: () =>
      import("@/views/myskool/reports/ChequeBookSummaryPrint.vue"),
    meta: {
      layout: "full",
      resource: "Auth",
      action: "read",
    },
  },
  {
    path: "/staff-timetable-print",
    name: "staff-timetable-print",
    component: () => import("@/views/myskool/reports/StaffTimeTablePrint.vue"),
    meta: {
      layout: "full",
      resource: "Auth",
      action: "read",
    },
  },
  {
    path: "/terms-history-print",
    name: "terms-history-print",
    component: () => import("@/views/myskool/reports/TermsHistoryPrint.vue"),
    meta: {
      layout: "full",
      resource: "Auth",
      action: "read",
    },
  },
  {
    path: "/terms-acknowledge-print",
    name: "terms-acknowledge-print",
    component: () =>
      import("@/views/myskool/reports/TermsAcknowledgePrint.vue"),
    meta: {
      layout: "full",
      resource: "Auth",
      action: "read",
    },
  },
  {
    path: "/student-email-report",
    name: "student-email-report",
    component: () => import("@/views/myskool/reports/StudentEmailPrint.vue"),
    meta: {
      layout: "full",
      resource: "Auth",
    },
  },
  {
    path: "/staff-increment-report",
    name: "staff-increment-report",
    component: () =>
      import("@/views/myskool/reports/StaffIncrementReportPrint.vue"),
    meta: {
      layout: "full",
      resource: "Auth",
    },
  },
  {
    path: "/staff-allocation-report",
    name: "staff-allocation-report",
    component: () =>
      import("@/views/myskool/reports/StaffAllocationPrint.vue"),
    meta: {
      layout: "full",
      resource: "Auth",
    },
  },
  {
    path: "/subject-fee-report",
    name: "subject-fee-report",
    component: () =>
      import("@/views/myskool/reports/SubjectFeeReportPrint.vue"),
    meta: {
      layout: "full",
      resource: "Auth",
    },
  },
  {
    path: "/subject-list-report",
    name: "subject-list-report",
    component: () =>
      import("@/views/myskool/reports/SubjectListReportPrint.vue"),
    meta: {
      layout: "full",
      resource: "Auth",
    },
  },
  {
    path: "/fee-concession-report",
    name: "fee-concession-report",
    component: () => import("@/views/myskool/reports/FeeConcessionPrint.vue"),
    meta: {
      layout: "full",
      resource: "Auth",
    },
  },
  {
    path: "/sibling-concession-report",
    name: "sibling-concession-report",
    component: () =>
      import("@/views/myskool/reports/SiblingConcessionPrint.vue"),
    meta: {
      layout: "full",
      resource: "Auth",
    },
  },
  {
    path: "/department-wise-discount-report",
    name: "department-wise-discount-report",
    component: () =>
      import("@/views/myskool/reports/DepartmentWiseDiscountPrint.vue"),
    meta: {
      layout: "full",
      resource: "Auth",
    },
  },
  {
    path: "/discount-summary-report",
    name: "discount-summary-report",
    component: () => import("@/views/myskool/reports/DiscountSummaryPrint.vue"),
    meta: {
      layout: "full",
      resource: "Auth",
    },
  },
  {
    path: "/student-tcf-print",
    name: "student-tcf-print",
    component: () => import("@/views/myskool/reports/StudentTcfPrint.vue"),
    meta: {
      layout: "full",
      resource: "Auth",
    },
  },
  {
    path: "/crestview-student-print",
    name: "crestview-student-print",
    component: () =>
      import("@/views/myskool/student/CrestViewStudentPrint.vue"),
    meta: {
      layout: "full",
      resource: "Auth",
    },
  },
  {
    path: "/app-stats-report",
    name: "app-stats-report",
    component: () => import("@/views/myskool/reports/AppStatsPrint.vue"),
    meta: {
      layout: "full",
      resource: "Auth",
    },
  },
  {
    path: "/pending-fees-after-admission-report",
    name: "pending-fees-after-admission-report",
    component: () =>
      import("@/views/myskool/reports/PendingFeesAfterAdmissionPrint.vue"),
    meta: {
      layout: "full",
      resource: "Auth",
    },
  },
  {
    path: "/outstanding-summary-report",
    name: "outstanding-summary-report",
    component: () =>
      import("@/views/myskool/reports/OutstandingSummaryPrint.vue"),
    meta: {
      layout: "full",
      resource: "Auth",
    },
  },
  {
    path: "/leave-encashment-report",
    name: "leave-encashment-report",
    component: () =>
      import("@/views/myskool/staff/LeaveEncashmentReportPrint.vue"),
    meta: {
      layout: "full",
      resource: "Auth",
    },
  },
  {
    path: "/leave-encashment-slip",
    name: "leave-encashment-slip",
    component: () =>
      import("@/views/myskool/staff/LeaveEncashmentSlipPrint.vue"),
    meta: {
      layout: "full",
      resource: "Auth",
    },
  },
  {
    path: "/inquiry-detail-print",
    name: "inquiry-detail-print",
    component: () => import("@/views/myskool/inquiry/InquiryDetailPrint.vue"),
    meta: {
      layout: "full",
      resource: "Auth",
    },
  },
  {
    path: "/student-turnover-report",
    name: "student-turnover-report",
    component: () => import("@/views/myskool/reports/StudentTurnoverPrint.vue"),
    meta: {
      layout: "full",
      resource: "Auth",
    },
  },
  {
    path: "/driver-wise-students-report",
    name: "driver-wise-students-report",
    component: () =>
      import("@/views/myskool/reports/DriverWiseStudentsPrint.vue"),
    meta: {
      layout: "full",
      resource: "Auth",
    },
  },
  {
    path: "/driver-fees-report",
    name: "driver-fees-report",
    component: () => import("@/views/myskool/reports/DriverFeesReportPrint.vue"),
    meta: {
      layout: "full",
      resource: "Auth",
    },
  },
  {
    path: "/farabi-coa-id-card",
    name: "farabi-coa-id-card",
    component: () => import("@/views/myskool/reports/FarabiCoaIDCard.vue"),
    meta: {
      layout: "full",
      resource: "Auth",
    },
  },
  {
    path: "/happiness-foundation-id-card",
    name: "happiness-foundation-id-card",
    component: () =>
      import("@/views/myskool/reports/happinessFoundationIDCard.vue"),
    meta: {
      layout: "full",
      resource: "Auth",
    },
  },
  {
    path: "/kent-id-card",
    name: "kent-id-card",
    component: () => import("@/views/myskool/reports/KentIDCard.vue"),
    meta: {
      layout: "full",
      resource: "Auth",
    },
  },
  {
    path: "/kent-staff-id-card",
    name: "kent-staff-id-card",
    component: () => import("@/views/myskool/reports/KentStaffIDCard.vue"),
    meta: {
      layout: "full",
      resource: "Auth",
    },
  },

  {
    path: "/kent-appointment-letter",
    name: "kent-appointment-letter",
    component: () =>
      import("@/views/myskool/reports/KentAppointmentLetterPrint.vue"),
    meta: {
      layout: "full",
      resource: "Auth",
    },
  },
  {
    path: "/kent-teachers-form",
    name: "kent-teachers-form",
    component: () =>
      import("@/views/myskool/reports/KentTeachersFormPrint.vue"),
    meta: {
      layout: "full",
      resource: "Auth",
    },
  },
  {
    path: "/file-cover",
    name: "file-cover",
    component: () => import("@/views/myskool/reports/FileCover.vue"),
    meta: {
      layout: "full",
      resource: "Auth",
      proceed: true,
    },
  },
  // #general
  {
    path: "/appointment-letter",
    name: "appointment-letter",
    component: () =>
      import("@/views/myskool/reports/VeritasAppointmentLetterPrint.vue"),
    meta: {
      layout: "full",
      resource: "Auth",
    },
  },
  {
    path: "/joining-letter",
    name: "joining-letter",
    component: () =>
      import("@/views/myskool/reports/VeritasTeachersFormPrint.vue"),
    meta: {
      layout: "full",
      resource: "Auth",
    },
  },
    // #general
  {
    path: "/smart-hassan-id-card",
    name: "smart-hassan-id-card",
    component: () => import("@/views/myskool/reports/SmartHassanIDCard.vue"),
    meta: {
      layout: "full",
      resource: "Auth",
    },
  },
  {
    path: "/smart-hassan-staff-id-card",
    name: "smart-hassan-staff-id-card",
    component: () =>
      import("@/views/myskool/reports/SmartHassanStaffIDCard.vue"),
    meta: {
      layout: "full",
      resource: "Auth",
    },
  },
  {
    path: "/beprince-id-card",
    name: "beprince-id-card",
    component: () => import("@/views/myskool/reports/beprinceIDCard.vue"),
    meta: {
      layout: "full",
      resource: "Auth",
    },
  },
    {
    path: "/hpgs-id-card",
    name: "hpgs-id-card",
    component: () => import("@/views/myskool/reports/HpgsIDCard.vue"),
    meta: {
      layout: "full",
      resource: "Auth",
    },
  },
  {
    path: "/hpgs-id-card-alevel",
    name: "hpgs-id-card-alevel",
    component: () => import("@/views/myskool/reports/HpgsIDCardAlevel.vue"),
    meta: {
      layout: "full",
      resource: "Auth",
    },
  },
  {
    path: "/scientist-term-result",
    name: "scientist-term-result",
    component: () => import("@/views/myskool/reports/ScientistTermResult.vue"),
    meta: {
      layout: "full",
      resource: "Auth",
    },
  },
  {
    path: "/inquiry-report-print",
    name: "inquiry-report-print",
    component: () => import("@/views/myskool/reports/InquiryReportPrint.vue"),
    meta: {
      layout: "full",
      resource: "Auth",
    },
  },
  {
    path: "/new-admission-list-report",
    name: "new-admission-list-report",
    component: () =>
      import("@/views/myskool/reports/NewAdmissionListPrint.vue"),
    meta: {
      layout: "full",
      resource: "Auth",
    },
  },
  {
    path: "/reconciliation-fees-report",
    name: "reconciliation-fees-report",
    component: () =>
      import("@/views/myskool/reports/ReconciliationFeesPrint.vue"),
    meta: {
      layout: "full",
      resource: "Auth",
    },
  },
  {
    path: "/class-verification-report",
    name: "class-verification-report",
    component: () =>
      import("@/views/myskool/reports/ClassVerificationPrint.vue"),
    meta: {
      layout: "full",
      resource: "Auth",
    },
  },
  {
    path: "/date-wise-strength-report",
    name: "date-wise-strength-report",
    component: () =>
      import("@/views/myskool/reports/DateWiseStrengthPrint.vue"),
    meta: {
      layout: "full",
      resource: "Auth",
    },
  },
  {
    path: "/campus-transfer-report",
    name: "campus-transfer-report",
    component: () => import("@/views/myskool/reports/CampusTransferPrint.vue"),
    meta: {
      layout: "full",
      resource: "Auth",
    },
  },
  {
    path: "/staff-campus-transfer-report",
    name: "staff-campus-transfer-report",
    component: () =>
      import("@/views/myskool/reports/StaffCampusTransferPrint.vue"),
    meta: {
      layout: "full",
      resource: "Auth",
    },
  },
  {
    path: "/fee-revenue-report",
    name: "fee-revenue-report",
    component: () => import("@/views/myskool/reports/FeeRevenuePrint.vue"),
    meta: {
      layout: "full",
      resource: "Auth",
    },
  },
  {
    path: "/ntn-certificate-report",
    name: "ntn-certificate-report",
    component: () => import("@/views/myskool/reports/NtnCertificatePrint.vue"),
    meta: {
      layout: "full",
      resource: "Auth",
    },
  },

  {
    path: "/class-list-iuss-report",
    name: "class-list-iuss-report",
    component: () => import("@/views/myskool/reports/ClassListIUSSPrint.vue"),
    meta: {
      layout: "full",
      resource: "Auth",
    },
  },
  {
    path: "/fee-status-report",
    name: "fee-status-report",
    component: () => import("@/views/myskool/reports/FeeStatusReportPrint.vue"),
    meta: {
      layout: "full",
      resource: "Auth",
    },
  },
  {
    path: "/extended-trial-balance-print",
    name: "extended-trial-balance-print",
    component: () =>
      import("@/views/myskool/reports/ExtendedTrialBalancePrint.vue"),
    meta: {
      layout: "full",
      resource: "Auth",
      action: "read",
    },
  },
  {
    path: "/aba-extended-trial-balance-print",
    name: "aba-extended-trial-balance-print",
    component: () =>
      import("@/views/myskool/reports/abaExtrendedtrailbalcne.vue"),
    meta: {
      layout: "full",
      resource: "Auth",
      action: "read",
    },
  },
  {
    path: "/fee-creator",
    name: "fee-creator",
    component: () => import("@/views/myskool/feestructure/feeCreator.vue"),
  },
  {
    path: "/fee-dashboard",
    name: "fee-dashboard",
    component: () => import("@/views/myskool/feestructure/feeDashboard.vue"),
  },
  {
    path: "/fee-reconcilation",
    name: "fee-reconcilation",
    component: () => import("@/views/myskool/feestructure/reconcilation.vue"),
  },
  {
    path: "/fee-reconciliation-full-report",
    name: "fee-reconciliation-full-report",
    component: () =>
      import("@/views/myskool/feestructure/FeeReconciliationFullPrint.vue"),
    meta: {
      layout: "full",
      resource: "Auth",
    },
  },
  {
    path: "/dues-summary",
    name: "dues-summary",
    component: () => import("@/views/myskool/feestructure/duesSummary.vue"),
  },
  {
    path: "/daily-collection",
    name: "daily-collection",
    component: () => import("@/views/myskool/feestructure/dailyCollection.vue"),
  },
  {
    path: "/manage-user",
    name: "manage-user",
    component: () => import("@/views/apps/user/users-list/UsersList.vue"),
  },
  {
    path: "/manage-userrights",
    name: "manage-userRights",
    component: () => import("@/views/myskool/management/userRights.vue"),
  },
  {
    path: "/manage-subjects",
    name: "manage-subjects",
    component: () => import("@/views/myskool/profiles/subjects.vue"),
  },
  {
    path: "/subjects",
    name: "manage-subjects-new",
    component: () => import("@/views/myskool/profiles/subjectsNew.vue"),
  },
  {
    path: "/manage-subject",
    name: "manage-subject",
    component: () => import("@/views/myskool/profiles/subjectsCoaching.vue"),
  },
  {
    path: "/exam-type",
    name: "exam-type",
    component: () => import("@/views/myskool/exam/examType.vue"),
  },
  {
    path: "/exam-groups",
    name: "exam-groups",
    component: () => import("@/views/myskool/exam/examGroups.vue"),
  },
  {
    path: "/exam-marks",
    name: "exam-marks",
    component: () => import("@/views/myskool/exam/examMarks.vue"),
  },
  {
    path: "/year-wise-result",
    name: "year-wise-result",
    component: () => import("@/views/myskool/exam/yearWiseResult.vue"),
  },
  {
    path: "/manage-marks",
    name: "manage-marks",
    component: () => import("@/views/myskool/exam/marksRedirect.vue"), // redirect to marks olevel page based on settings otherwise normal marks entry page
    // component: () => import("@/views/myskool/exam/marksEntry.vue"),
  },
  // {
  //   path: "/marks-olevel",
  //   name: "marks-olevel",
  //   component: () => import("@/views/myskool/exam/marksEntryOLevel.vue"),
  // },
  {
    path: "/marks-entry-staff",
    name: "marks-entry-staff",
    component: () => import("@/views/myskool/exam/marksEntrySimple.vue"),
  },
  {
    path: "/marks-entry-student",
    name: "marks-entry-student",
    component: () => import("@/views/myskool/exam/marksEntryStudent.vue"),
  },
  {
    path: "/marks-record",
    name: "marks-record",
    component: () => import("@/views/myskool/exam/marksRecord.vue"),
  },
  {
    path: "/marks",
    name: "marks",
    component: () => import("@/views/myskool/exam/marksEntryAll.vue"),
  },
  {
    path: "/marks-sub",
    name: "marks-sub",
    component: () => import("@/views/myskool/exam/marksEntrySub.vue"),
  },
  {
    path: "/marks-coaching",
    name: "marks-coaching",
    component: () => import("@/views/myskool/exam/marksEntryIota.vue"),
  },
  {
    path: "/comment-bank",
    name: "comment-bank",
    component: () => import("@/views/myskool/exam/commentbank.vue"),
  },
  {
    path: "/comment-categorize",
    name: "comment-categorize",
    component: () => import("@/views/myskool/exam/CommentCategorize.vue"),
  },
  {
    path: "/report-template",
    name: "report-template",
    component: () => import("@/views/myskool/exam/dataTemplate.vue"),
  },
  {
    path: "/consent-form",
    name: "consent-form",
    component: () => import("@/views/myskool/exam/consentForm.vue"),
  },

  {
    path: "/reports/consent-print",
    name: "consent-print",
    component: () => import("@/views/myskool/reports/ConsentPrint.vue"),
    meta: {
      layout: "full",
      resource: "Auth",
    },
  },
  {
    path: "/carnival-inquiries",
    name: "carnival-inquiries",
    component: () => import("@/views/myskool/others/carnivalInquiries.vue"),
  },
  {
    path: "/convocation-form",
    name: "convocation-form",
    component: () =>
      import("@/views/myskool/others/ConvocationFormManage.vue"),
  },
  {
    path: "/convocation-registration-report",
    name: "convocation-registration-report",
    component: () =>
      import("@/views/myskool/reports/ConvocationRegistrationPrint.vue"),
    meta: {
      layout: "full",
      resource: "Auth",
    },
  },
  {
    path: "/convocation-registration",
    name: "convocation-registration",
    component: () =>
      import("@/views/myskool/others/ConvocationRegistrationPublic.vue"),
    meta: {
      layout: "full",
      resource: "Auth",
      proceed: true,
    },
  },
  {
    path: "/notification-history",
    name: "notification-history",
    component: () => import("@/views/myskool/others/notificationHistory.vue"),
  },
  {
    path: "/tabulation-sheet",
    name: "tabulation-sheet",
    component: () =>
      import("@/views/myskool/tabulation/TabulationSheetBuilder.vue"),
  },
  {
    path: "/tabulation-sheet/add",
    name: "tabulation-sheet-add",
    component: () =>
      import("@/views/myskool/tabulation/TabulationSheetForm.vue"),
  },
  {
    path: "/tabulation-sheet/edit/:id",
    name: "tabulation-sheet-edit",
    component: () =>
      import("@/views/myskool/tabulation/TabulationSheetForm.vue"),
    props: true,
  },
  {
    path: "/tabulation-sheet/view/:id",
    name: "tabulation-sheet-view",
    component: () =>
      import("@/views/myskool/tabulation/TabulationSheetForm.vue"),
    props: true,
  },
  {
    path: "/tabulation-sheet-replication",
    name: "tabulation-sheet-replication",
    component: () =>
      import("@/views/myskool/tabulation/TabulationSheetReplication.vue"),
  },
  {
    path: "/print-result",
    name: "print-result",
    component: () => import("@/views/myskool/exam/printResultMe.vue"),
  },
  {
    path: "/grading",
    name: "grading",
    component: () => import("@/views/myskool/exam/grading.vue"),
  },
  {
    path: "/grading-reward",
    name: "grading-reward",
    component: () => import("@/views/myskool/exam/gradingReward.vue"),
  },
  {
    path: "/grading-class",
    name: "grading-class",
    component: () => import("@/views/myskool/exam/gradingClasswise.vue"),
  },
  {
    path: "/remarks",
    name: "remarks",
    component: () => import("@/views/myskool/exam/remarks.vue"),
  },
  {
    path: "/sessions",
    name: "sessions",
    component: () => import("@/views/myskool/sessions/sessions.vue"),
  },
  {
    path: "/workingdays",
    name: "workingdays",
    component: () => import("@/views/myskool/sessions/workingDays.vue"),
  },
  {
    path: "/timetable/:id",
    name: "timetable",
    component: () => import("@/views/myskool/sessions/timetable.vue"),
    props: true,
  },
  {
    path: "/staff-timetable-calendar",
    name: "staff-timetable-calendar",
    component: () =>
      import("@/views/myskool/sessions/staffTimetableCalendar.vue"),
  },
  {
    path: "/day-wise-planner",
    name: "day-wise-planner",
    component: () => import("@/views/myskool/daywiseplanner/planner.vue"),
  },
  {
    path: "/timetable",
    name: "assign-timetable",
    component: () => import("@/views/myskool/sessions/assignTimetable.vue"),
  },
  {
    path: "/schedule",
    name: "schedule",
    component: () => import("@/views/myskool/sessions/Schedule.vue"),
  },
  {
    path: "/accounts",
    name: "accounts",
    component: () => import("@/views/myskool/accounts/chartOfAccounts.vue"),
  },
  {
    path: "/bank-reconciliation",
    name: "bank-reconciliation",
    component: () => import("@/views/myskool/accounts/bankReconciliation.vue"),
  },
  {
    path: "/journal",
    name: "journal",
    component: () => import("@/views/myskool/accounts/journal.vue"),
  },
  {
    path: "/journal-advance",
    name: "journal-advance",
    component: () => import("@/views/myskool/accounts/journalAdvance.vue"),
    props: { voucherMode: "journal" },
  },
  {
    path: "/bank-voucher",
    name: "bank-voucher",
    component: () => import("@/views/myskool/accounts/journalAdvance.vue"),
    props: { voucherMode: "bank" },
  },
  {
    path: "/credit-voucher",
    name: "credit-voucher",
    component: () => import("@/views/myskool/accounts/journalAdvance.vue"),
    props: { voucherMode: "credit" },
  },
  {
    path: "/transfer-voucher",
    name: "transfer-voucher",
    component: () => import("@/views/myskool/accounts/journalAdvance.vue"),
    props: { voucherMode: "transfer" },
  },
  {
    path: "/all-voucher",
    name: "all-voucher",
    component: () => import("@/views/myskool/accounts/journalAdvance.vue"),
    props: { voucherMode: "all" },
  },
  {
    path: "/accounting/:id",
    name: "accounting",
    component: () => import("@/views/myskool/accounts/accounting.vue"),
  },
  {
    path: "/accounting-advance/:id",
    name: "accounting-advance",
    component: () => import("@/views/myskool/accounts/accountingAdvance.vue"),
    props: (route) => ({
      id: route.params.id,
      voucherMode: route.query.voucherMode || "journal",
      voucherType: route.query.voucherType || "",
    }),
  },
  {
    path: "/accounting-project/:id",
    name: "accounting-project",
    component: () => import("@/views/myskool/accounts/accountingProject.vue"),
  },
  {
    path: "/accounting-club-entry",
    name: "accounting-club-entry",
    component: () => import("@/views/myskool/accounts/accountingClubEntry.vue"),
  },
  {
    path: "/tax-categories",
    name: "tax-categories",
    component: () => import("@/views/myskool/accounts/taxCategories.vue"),
  },
  {
    path: "/fixed-assets",
    name: "fixed-assets",
    component: () => import("@/views/myskool/accounts/fixedAssets.vue"),
  },
  {
    path: "/planner-form/:id",
    name: "planner-form",
    component: () => import("@/views/myskool/planner/plannerForm.vue"),
  },
  {
    path: "/planner-sheet",
    name: "planner-sheet",
    component: () => import("@/views/myskool/planner/plannerSheet.vue"),
  },
  {
    path: "/planner-sheet-form/:id",
    name: "planner-sheet-form",
    component: () => import("@/views/myskool/planner/plannerSheetForm.vue"),
  },
  {
    path: "/planner-sheet-aba",
    name: "planner-sheet-aba",
    component: () => import("@/views/myskool/planner/plannerSheetAba.vue"),
    meta: {
      layout: "full",
      resource: "Auth",
    },
  },
  {
    path: "/planner-sheet-deenway",
    name: "planner-sheet-deenway",
    component: () => import("@/views/myskool/planner/plannerSheetDeenway.vue"),
    meta: {
      layout: "full",
      resource: "Auth",
    },
  },
  {
    path: "/planner-sheet-print",
    name: "planner-sheet-print",
    component: () => import("@/views/myskool/planner/PlannerSheetPrint.vue"),
    meta: {
      layout: "full",
      resource: "Auth",
    },
  },
  {
    path: "/planner-daywise-deenway",
    name: "planner-daywise-deenway",
    component: () =>
      import("@/views/myskool/daywiseplanner/plannerDayWiseDeenway.vue"),
    meta: {
      layout: "full",
      resource: "Auth",
    },
  },
  {
    path: "/planner-daywise-print",
    name: "planner-daywise-print",
    component: () =>
      import("@/views/myskool/daywiseplanner/PlannerDayWisePrint.vue"),
    meta: {
      layout: "full",
      resource: "Auth",
    },
  },
  {
    path: "/planner-headers",
    name: "planner-headers",
    component: () => import("@/views/myskool/planner/PlannerHeaders.vue"),
  },
  {
    path: "/planner-calendar",
    name: "planner-calendar",
    component: () => import("@/views/apps/planner-calendar/Calendar.vue"),
  },
  {
    path: "/concepts",
    name: "concepts",
    component: () => import("@/views/myskool/planner/Concepts.vue"),
  },
  {
    path: "/topics",
    name: "topics",
    component: () => import("@/views/myskool/planner/Topics.vue"),
  },
  {
    path: "/week-labels",
    name: "week-labels",
    component: () => import("@/views/myskool/planner/WeekTile.vue"),
  },
  {
    path: "/replicate-planner",
    name: "replicate-planner",
    component: () => import("@/views/myskool/planner/ReplicationPlanner.vue"),
  },
  {
    path: "/publish-planner",
    name: "publish-planner",
    component: () => import("@/views/myskool/planner/PublishPlannerNewV.vue"),
  },
  {
    path: "/replicate-planner-form/:id",
    name: "replication-planner-form",
    component: () =>
      import("@/views/myskool/planner/ReplicatePlannerFormNewV.vue"),
  },
  {
    path: "/planner-subtopics",
    name: "planner-subtopics",
    component: () => import("@/views/myskool/planner/Subtopics.vue"),
  },
  {
    path: "/monthly-breakup",
    name: "monthly-breakup",
    component: () => import("@/views/myskool/breakup/MonthlyBreakup.vue"),
  },
  {
    path: "/monthly-breakup-print",
    name: "monthly-breakup-print",
    component: () => import("@/views/myskool/breakup/MonthlyBreakupPrint.vue"),
    meta: {
      layout: "full",
      resource: "Auth",
    },
  },
  {
    path: "/weekly-breakup",
    name: "weekly-breakup",
    component: () => import("@/views/myskool/breakup/WeeklyBreakup.vue"),
  },
  {
    path: "/weekly-breakup-print",
    name: "weekly-breakup-print",
    component: () => import("@/views/myskool/breakup/WeeklyBreakupPrint.vue"),
    meta: {
      layout: "full",
      resource: "Auth",
    },
  },
  {
    path: "/manage-vendors",
    name: "manage-vendors",
    component: () => import("@/views/myskool/accounts/vendors.vue"),
  },
  {
    path: "/manage-suppliers",
    name: "manage-suppliers",
    component: () => import("@/views/myskool/accounts/supplier.vue"),
  },
  {
    path: "/expenses",
    name: "expenses",
    component: () => import("@/views/myskool/accounts/expenses.vue"),
  },
  {
    path: "/income",
    name: "income",
    component: () => import("@/views/myskool/accounts/income.vue"),
  },
  {
    path: "/opening-balance",
    name: "opening-balance",
    component: () => import("@/views/myskool/accounts/openingBalance.vue"),
  },
  {
    path: "/other-income",
    name: "other-income",
    component: () => import("@/views/myskool/accounts/otherIncome.vue"),
  },
  {
    path: "/audit-logs",
    name: "audit-logs",
    component: () => import("@/views/myskool/accounts/auditLogs.vue"),
  },
  {
    path: "/manage-chequebook",
    name: "manage-chequebook",
    component: () => import("@/views/myskool/accounts/chequeBook.vue"),
  },
  {
    path: "/bank-deposit",
    name: "bank-deposit",
    component: () => import("@/views/myskool/accounts/bankDeposit.vue"),
  },
  {
    path: "/student-attendance",
    name: "student-attendance",
    component: () => import("@/views/myskool/student/studentAttendance.vue"),
  },
  {
    path: "/student-attendance-subject",
    name: "student-attendance-subject",
    component: () =>
      import("@/views/myskool/student/studentAttendanceSubject.vue"),
  },
  {
    path: "/student-attendance-summary",
    name: "student-attendance-summary",
    component: () => import("@/views/myskool/student/attendanceSummary.vue"),
  },
  {
    path: "/attendance-sync",
    name: "attendance-sync",
    component: () =>
      import("@/views/myskool/student/studentAttendanceSync.vue"),
  },
  {
    path: "/monthly-attendance",
    name: "monthly-attendance",
    component: () => import("@/views/myskool/student/monthlyAttendance.vue"),
  },
  {
    path: "/monthly-attendance-status-report-print",
    name: "monthly-attendance-status-report-print",
    component: () =>
      import("@/views/myskool/student/MonthlyAttendanceStatusReportPrint.vue"),
    meta: {
      layout: "full",
      resource: "Auth",
    },
  },
  {
    path: "/attendance-dashboard",
    name: "attendance-dashboard",
    component: () => import("@/views/myskool/student/attendanceDashboard.vue"),
  },
  {
    path: "/staff-attendance",
    name: "staff-attendance",
    component: () => import("@/views/myskool/staff/staffAttendance.vue"),
  },
  {
    path: "/staff-attendance-timing-schedule",
    name: "staff-attendance-timing-schedule",
    component: () =>
      import("@/views/myskool/staff/StaffAttendanceTimingSchedule.vue"),
  },
  {
    path: "/half-day-policy",
    name: "half-day-policy",
    component: () => import("@/views/myskool/staff/HalfDayPolicy.vue"),
  },
  {
    path: "/policy",
    name: "policy",
    component: () => import("@/views/myskool/others/policy.vue"),
  },
  {
    path: "/terms-and-conditions",
    name: "terms-and-conditions",
    component: () => import("@/views/myskool/others/termsAndConditions.vue"),
  },

  {
    path: "/report",
    name: "report",
    component: () => import("@/views/myskool/reports/reports.vue"),
  },
  {
    path: "/templates",
    name: "templates",
    component: () => import("@/views/myskool/message/templates.vue"),
  },

  {
    path: "/send-messages",
    name: "apps-chat",
    component: () => import("@/views/apps/chat/Chat.vue"),
    // component: () => import("@/views/apps/chat/Chat2.vue"),
    meta: {
      contentRenderer: "sidebar-left",
      contentClass: "chat-application",
    },
  },
  {
    path: "/groups",
    name: "apps-groups",
    component: () => import("@/views/apps/groups/Chat.vue"),
    meta: {
      contentRenderer: "sidebar-left",
      contentClass: "chat-application",
    },
  },

  {
    path: "/whatsapp-bot",
    name: "whatsapp-bot",
    component: () => import("@/views/myskool/message/whatsappBot.vue"),
  },
  {
    path: "/outbox",
    name: "outbox",
    component: () => import("@/views/myskool/message/outbox.vue"),
  },
  {
    path: "/sentbox",
    name: "sentbox",
    component: () => import("@/views/myskool/message/sentbox.vue"),
  },
  {
    path: "/sms-settings",
    name: "sms-settings",
    component: () => import("@/views/myskool/message/SmsSettings.vue"),
  },
  {
    path: "/manage-poll",
    name: "manage-poll",
    component: () => import("@/views/myskool/message/poll.vue"),
  },
  {
    path: "/profile-dashboard",
    name: "profile-dashboard",
    component: () => import("@/views/myskool/profiles/profileDashboard.vue"),
  },
  {
    path: "/principal-dashboard",
    name: "principal-dashboard",
    component: () => import("@/views/myskool/profiles/principalDashboard.vue"),
  },
  {
    path: "/headoffice-dashboard",
    name: "headoffice-dashboard",
    component: () => import("@/views/myskool/profiles/headofficeDashboard.vue"),
  },
  {
    path: "/demo-dashboard",
    name: "demo-dashboard",
    component: () =>
      import("@/views/myskool/profiles/demoExecutiveDashboard.vue"),
  },
  {
    path: "/library",
    name: "library",
    component: () => import("@/views/myskool/resources/library.vue"),
  },
  {
    path: "/homework",
    name: "homework",
    component: () => import("@/views/myskool/resources/homework.vue"),
  },
  {
    path: "/resource",
    name: "resource",
    component: () => import("@/views/myskool/resources/resource.vue"),
  },
  {
    path: "/online-classes",
    name: "online-classes",
    component: () => import("@/views/myskool/resources/onlineClasses.vue"),
  },
  {
    path: "/join-class/:id",
    name: "join-class",
    component: () => import("@/views/myskool/resources/joinClass.vue"),
    meta: {
      layout: "full",
      resource: "Auth",
      proceed: true,
    },
  },
  {
    path: "/live-classes",
    name: "live-classes",
    component: () => import("@/views/myskool/resources/liveClasses.vue"),
    meta: {
      layout: "full",
      resource: "Auth",
      proceed: true,
    },
  },
  {
    path: "/lectures",
    name: "lectures",
    component: () => import("@/views/myskool/resources/lectures.vue"),
  },
  {
    path: "/book-list",
    name: "book-list",
    component: () => import("@/views/myskool/resources/bookList.vue"),
  },
  {
    path: "/book-list/add",
    name: "book-list-add",
    component: () => import("@/views/myskool/resources/bookListForm.vue"),
  },
  {
    path: "/book-list/edit/:id",
    name: "book-list-edit",
    component: () => import("@/views/myskool/resources/bookListForm.vue"),
    props: true,
  },
  {
    path: "/book-list/view/:id",
    name: "book-list-view",
    component: () => import("@/views/myskool/resources/bookListForm.vue"),
    props: true,
  },
  {
    path: "/book-list/crestview/add",
    name: "book-list-crestview-add",
    component: () =>
      import("@/views/myskool/resources/bookListCrestViewForm.vue"),
  },
  {
    path: "/book-list/crestview/edit/:id",
    name: "book-list-crestview-edit",
    component: () =>
      import("@/views/myskool/resources/bookListCrestViewForm.vue"),
    props: true,
  },
  {
    path: "/book-list/crestview/view/:id",
    name: "book-list-crestview-view",
    component: () =>
      import("@/views/myskool/resources/bookListCrestViewForm.vue"),
    props: true,
  },
  {
    path: "/book-list/crestview/print",
    name: "book-list-crestview-print",
    component: () =>
      import("@/views/myskool/resources/BookListCrestViewPrint.vue"),
    meta: {
      layout: "full",
      proceed: true,
    },
  },
  {
    path: "/book-list-record",
    name: "book-list-record",
    component: () => import("@/views/myskool/resources/bookListRecord.vue"),
  },
  {
    path: "/book-list-summary-report",
    name: "book-list-summary-report",
    component: () => import("@/views/myskool/reports/BookListSummaryPrint.vue"),
    meta: {
      layout: "full",
      resource: "Auth",
    },
  },
  {
    path: "/book-list-category-report",
    name: "book-list-category-report",
    component: () =>
      import("@/views/myskool/reports/BookListCategoryPrint.vue"),
    meta: {
      layout: "full",
      resource: "Auth",
    },
  },
  {
    path: "/admit-card",
    name: "admit-card",
    component: () => import("@/views/myskool/resources/admitCard.vue"),
    meta: {
      layout: "full",
      resource: "Auth",
      proceed: true,
    },
  },
  {
    path: "/form-requests",
    name: "form-requests",
    component: () => import("@/views/myskool/resources/formRequests.vue"),
  },
  {
    path: "/card-requests",
    name: "card-requests",
    component: () => import("@/views/myskool/resources/cardRequests.vue"),
  },
  {
    path: "/inquiry-elixir",
    name: "inquiry-elixir",
    component: () => import("@/views/myskool/inquiry/inquiryElixir.vue"),
    meta: {
      layout: "full",
      resource: "Auth",
      proceed: true,
    },
  },
  {
    path: "/inquiry-hpgs",
    name: "inquiry-hpgs",
    component: () => import("@/views/myskool/inquiry/inquiryHpgs.vue"),
    meta: {
      layout: "full",
      resource: "Auth",
      proceed: true,
    },
  },
  {
    path: "/school-inquiry",
    name: "school-inquiry",
    component: () => import("@/views/myskool/inquiry/inquiryPublic.vue"),
    meta: {
      layout: "full",
      resource: "Auth",
      proceed: true,
    },
  },
  {
    path: "/hasan-inquiry",
    name: "school-inquiry-hasan",
    alias: "/inquiry/hasan",
    component: () => import("@/views/myskool/inquiry/inquiryPublic.vue"),
    meta: {
      layout: "full",
      resource: "Auth",
      proceed: true,
    },
  },
  {
    path: "/inquiry-veritas",
    name: "inquiry-veritas",
    component: () => import("@/views/myskool/inquiry/inquiryVeritas.vue"),
    meta: {
      layout: "full",
      resource: "Auth",
      proceed: true,
    },
  },
  {
    path: "/add-staff",
    name: "add-staff",
    component: () => import("@/views/myskool/staff/addStaff.vue"),
    meta: {
      layout: "full",
      resource: "Auth",
      proceed: true,
    },
  },
  {
    path: "/staff-registration",
    name: "staff-registration",
    component: () => import("@/views/myskool/others/staffRegistration.vue"),
    meta: {
      layout: "full",
      resource: "Auth",
      proceed: true,
    },
  },
  {
    path: "/student-registration",
    name: "student-registration",
    component: () => import("@/views/myskool/others/studentRegistration.vue"),
    meta: {
      layout: "full",
      resource: "Auth",
      proceed: true,
    },
  },
  {
    path: "/crestview-student-registration",
    name: "crestview-student-registration",
    component: () =>
      import("@/views/myskool/others/crestViewStudentRegistration.vue"),
    meta: {
      layout: "full",
      resource: "Auth",
      proceed: true,
    },
  },
  {
    path: "/registration",
    name: "registration",
    component: () => import("@/views/myskool/student/registration.vue"),
    meta: {
      layout: "full",
      resource: "Auth",
      proceed: true,
    },
  },
  {
    path: "/help-palestine",
    name: "help-palestine",
    component: () => import("@/views/myskool/others/palestine.vue"),
    meta: {
      layout: "full",
      resource: "Auth",
      proceed: true,
    },
  },
  // ==== szablc ====
  {
    path: "/student-enrollment",
    name: "student-enrollment",
    component: () => import("@/views/myskool/others/studentEnrollment.vue"),
    meta: {
      layout: "full",
      resource: "Auth",
      proceed: true,
    },
  },
  {
    path: "/student-admission",
    name: "student-admission",
    component: () => import("@/views/myskool/others/studentAdmission.vue"),
    meta: {
      layout: "full",
      resource: "Auth",
      proceed: true,
    },
  },
  // ==== szablc ====
  {
    path: "/branding",
    name: "branding",
    component: () => import("@/views/myskool/others/branding.vue"),
  },
  {
    path: "/donations",
    name: "donations",
    component: () => import("@/views/myskool/donations/donations.vue"),
  },
  {
    path: "/staff-salary",
    name: "staff-salary",
    component: () => import("@/views/myskool/staff/staffSalary.vue"),
  },
  {
    path: "/salary",
    name: "salary",
    component: () => import("@/views/myskool/staff/shareSalary.vue"),
  },
  {
    path: "/manage-quiz",
    name: "manage-quiz",
    component: () => import("@/views/myskool/quiz/manageQuiz.vue"),
  },
  {
    path: "/quiz-question/:id",
    name: "quiz-question",
    component: () => import("@/views/myskool/quiz/questions.vue"),
  },
  {
    path: "/create-quiz/:id",
    name: "create-quiz",
    component: () => import("@/views/myskool/quiz/createQuiz.vue"),
  },
  {
    path: "/question-paper",
    name: "question-paper",
    component: () => import("@/views/myskool/quiz/questionPaper.vue"),
  },
  {
    path: "/quiz",
    name: "quiz",
    component: () => import("@/views/myskool/quiz/quiz.vue"),
  },
  // {
  //   path: "/quiz",
  //   name: "quiz-auto",
  //   component: () => import("@/views/myskool/quiz/quizAuto.vue"),
  // },
  {
    path: "/manage-datesheet",
    name: "manage-datesheet",
    component: () => import("@/views/myskool/exam/datesheetGrid.vue"),
  },
  {
    path: "/datesheet/:id",
    name: "datesheet",
    component: () => import("@/views/myskool/exam/datesheet.vue"),
  },
  {
    path: "/manage-planner/:id?",
    name: "manage-planner",
    component: () => import("@/views/myskool/planner/plannerGrid.vue"),
  },
  {
    path: "/planner/:id",
    name: "planner",
    component: () => import("@/views/myskool/planner/planner.vue"),
  },
  {
    path: "/inventory",
    name: "inventory",
    component: () => import("@/views/myskool/inventory/inventory.vue"),
  },
  {
    path: "/inventory-stock-print",
    name: "inventory-stock-print",
    component: () =>
      import("@/views/myskool/inventory/InventoryStockPrint.vue"),
    meta: {
      layout: "full",
      resource: "Auth",
      proceed: true,
    },
  },
  {
    path: "/stock-log-report-print",
    name: "stock-log-report-print",
    component: () =>
      import("@/views/myskool/inventory/StockLogReportPrint.vue"),
    meta: {
      layout: "full",
      resource: "Auth",
      proceed: true,
    },
  },
  {
    path: "/warehouse",
    name: "warehouse",
    component: () => import("@/views/myskool/inventory/warehouse.vue"),
  },
  {
    path: "/sales",
    name: "sales",
    component: () => import("@/views/myskool/inventory/sales.vue"),
  },
  {
    path: "/sales-transactions",
    name: "sales-transactions",
    component: () => import("@/views/myskool/inventory/salesTransactions.vue"),
  },
  {
    path: "/gate-pass",
    name: "gate-pass",
    component: () => import("@/views/myskool/inventory/gatePass.vue"),
  },
  {
    path: "/goods-receiving",
    name: "goods-receiving",
    component: () => import("@/views/myskool/inventory/goodsReceiving.vue"),
  },
  {
    path: "/manage-buildings",
    name: "manage-buildings",
    component: () => import("@/views/myskool/inventory/building.vue"),
  },
  {
    path: "/maintenance",
    name: "maintenance",
    component: () => import("@/views/myskool/inventory/maintenance.vue"),
  },
  {
    path: "/billing",
    name: "apps-billing",
    component: () => import("@/views/apps/billing/Chat.vue"),
    meta: {
      contentRenderer: "sidebar-left",
      contentClass: "chat-application",
    },
  },
  {
    path: "/fee-increment",
    name: "fee-increment",
    component: () => import("@/views/myskool/feestructure/feeIncrement.vue"),
    meta: {
      contentRenderer: "sidebar-left",
      contentClass: "chat-application",
    },
  },
  {
    path: "/homework-new",
    name: "homework-new",
    component: () => import("@/views/myskool/resources/homeWorkNew.vue"),
  },
  {
    path: "/homework-staff",
    name: "homework-staff",
    component: () => import("@/views/myskool/teachers/homeworkStaff.vue"),
  },
  {
    path: "/attendance-staff",
    name: "attendance-staff",
    component: () =>
      import("@/views/myskool/teachers/studentAttendanceStaff.vue"),
  },
  {
    path: "/marks-staff",
    name: "marks-staff",
    component: () => import("@/views/myskool/teachers/marksStaff.vue"),
  },
  {
    path: "/teachers-dashboard",
    name: "teachers-dashboard",
    component: () => import("@/views/myskool/teachersOverview/Dashboard.vue"),
  },
  {
    path: "/teachers-students",
    name: "teachers-students",
    component: () =>
      import("@/views/myskool/teachersOverview/StudentsStats.vue"),
  },
  {
    path: "/teachers-assessments",
    name: "teachers-assessments",
    component: () => import("@/views/myskool/teachersOverview/Assessments.vue"),
  },
  {
    path: "/school-performance",
    name: "school-performance",
    component: () => import("@/views/myskool/schoolOverview/Performance.vue"),
  },
  {
    path: "/grade-comparison",
    name: "grade-comparison",
    component: () =>
      import("@/views/myskool/schoolOverview/GradeComparison.vue"),
  },
  {
    path: "/teacher-analytics",
    name: "teacher-analytics",
    component: () =>
      import("@/views/myskool/schoolOverview/TeacherAnalytics.vue"),
  },
  {
    path: "/district-analytics",
    name: "district-analytics",
    component: () =>
      import("@/views/myskool/DistrictOverview/DistrictAnalytics.vue"),
  },
  {
    path: "/accountability",
    name: "accountability",
    component: () =>
      import("@/views/myskool/DistrictOverview/Accountability.vue"),
  },
  {
    path: "/data-imports",
    name: "data-imports",
    component: () => import("@/views/myskool/DistrictOverview/DataImports.vue"),
  },
  {
    path: "/apps/webinar",
    name: "webinar",
    component: () => import("@/views/myskool/teachers/webinar.vue"),
    meta: {
      layout: "full",
      resource: "Auth",
      proceed: true,
    },
  },

  // *===============================================---*
  // *--------- EMAIL & IT'S FILTERS N LABELS -------------------------------*
  // *===============================================---*
  {
    path: "/apps/email",
    name: "apps-email",
    component: () => import("@/views/apps/email/Email.vue"),
    meta: {
      contentRenderer: "sidebar-left",
      contentClass: "email-application",
    },
  },
  {
    path: "/apps/email/:folder",
    name: "apps-email-folder",
    component: () => import("@/views/apps/email/Email.vue"),
    meta: {
      contentRenderer: "sidebar-left",
      contentClass: "email-application",
      navActiveLink: "apps-email",
    },
    beforeEnter(to, _, next) {
      if (
        ["sent", "draft", "starred", "spam", "trash"].includes(to.params.folder)
      )
        next();
      else next({ name: "error-404" });
    },
  },
  {
    path: "/apps/email/label/:label",
    name: "apps-email-label",
    component: () => import("@/views/apps/email/Email.vue"),
    meta: {
      contentRenderer: "sidebar-left",
      contentClass: "email-application",
      navActiveLink: "apps-email",
    },
    beforeEnter(to, _, next) {
      if (
        ["personal", "company", "important", "private"].includes(
          to.params.label
        )
      )
        next();
      else next({ name: "error-404" });
    },
  },

  // *===============================================---*
  // *--------- TODO & IT'S FILTERS N TAGS ---------------------------------------*
  // *===============================================---*
  {
    path: "/apps/todo",
    name: "apps-todo",
    component: () => import("@/views/apps/todo/Todo.vue"),
    meta: {
      contentRenderer: "sidebar-left",
      contentClass: "todo-application",
    },
  },
  {
    path: "/apps/todo/:filter",
    name: "apps-todo-filter",
    component: () => import("@/views/apps/todo/Todo.vue"),
    meta: {
      contentRenderer: "sidebar-left",
      contentClass: "todo-application",
      navActiveLink: "apps-todo",
    },
    beforeEnter(to, _, next) {
      if (["important", "completed", "deleted"].includes(to.params.filter))
        next();
      else next({ name: "error-404" });
    },
  },
  {
    path: "/apps/todo/tag/:tag",
    name: "apps-todo-tag",
    component: () => import("@/views/apps/todo/Todo.vue"),
    meta: {
      contentRenderer: "sidebar-left",
      contentClass: "todo-application",
      navActiveLink: "apps-todo",
    },
    // beforeEnter(to, _, next) {
    //   if (["team", "low", "medium", "high", "update"].includes(to.params.tag))
    //     next();
    //   else next({ name: "error-404" });
    // },
  },

  // *===============================================---*
  // *--------- CHAT  ---------------------------------------*
  // *===============================================---*

  // *===============================================---*
  // *--------- ECOMMERCE  ---------------------------------------*
  // *===============================================---*
  {
    path: "/apps/e-commerce/shop",
    name: "apps-e-commerce-shop",
    component: () =>
      import("@/views/apps/e-commerce/e-commerce-shop/ECommerceShop.vue"),
    meta: {
      contentRenderer: "sidebar-left-detached",
      contentClass: "ecommerce-application",
      pageTitle: "Shop",
      breadcrumb: [
        {
          text: "ECommerce",
        },
        {
          text: "Shop",
          active: true,
        },
      ],
    },
  },
  {
    path: "/apps/e-commerce/wishlist",
    name: "apps-e-commerce-wishlist",
    component: () =>
      import(
        "@/views/apps/e-commerce/e-commerce-wishlist/ECommerceWishlist.vue"
      ),
    meta: {
      pageTitle: "Wishlist",
      contentClass: "ecommerce-application",
      breadcrumb: [
        {
          text: "ECommerce",
        },
        {
          text: "Wishlist",
          active: true,
        },
      ],
    },
  },
  {
    path: "/apps/e-commerce/checkout",
    name: "apps-e-commerce-checkout",
    component: () =>
      import(
        "@/views/apps/e-commerce/e-commerce-checkout/ECommerceCheckout.vue"
      ),
    meta: {
      pageTitle: "Checkout",
      contentClass: "ecommerce-application",
      breadcrumb: [
        {
          text: "ECommerce",
        },
        {
          text: "Checkout",
          active: true,
        },
      ],
    },
  },
  {
    path: "/apps/e-commerce/:slug",
    name: "apps-e-commerce-product-details",
    component: () =>
      import(
        "@/views/apps/e-commerce/e-commerce-product-details/ECommerceProductDetails.vue"
      ),
    meta: {
      pageTitle: "Product Details",
      contentClass: "ecommerce-application",
      breadcrumb: [
        {
          text: "ECommerce",
        },
        {
          text: "Shop",
          active: true,
        },
        {
          text: "Product Details",
          active: true,
        },
      ],
    },
  },

  // *===============================================---*
  // *--------- USER ---- ---------------------------------------*
  // *===============================================---*
  {
    path: "/apps/users/list",
    name: "apps-users-list",
    component: () => import("@/views/apps/user/users-list/UsersList.vue"),
  },
  {
    path: "/apps/users/view/:id/:item",
    name: "apps-users-view",
    component: () => import("@/views/apps/user/users-view/UsersView.vue"),
    props: true,
  },
  {
    path: "/apps/users/edit/:id",
    name: "apps-users-edit",
    component: () => import("@/views/apps/user/users-edit/UsersEdit.vue"),
  },

  // Invoice
  {
    path: "/apps/invoice/list",
    name: "apps-invoice-list",
    component: () =>
      import("@/views/apps/invoice/invoice-list/InvoiceList.vue"),
  },
  {
    path: "/apps/invoice/preview/:id",
    name: "apps-invoice-preview",
    component: () =>
      import("@/views/apps/invoice/invoice-preview/InvoicePreview.vue"),
  },
  {
    path: "/apps/invoice/add/",
    name: "apps-invoice-add",
    component: () => import("@/views/apps/invoice/invoice-add/InvoiceAdd.vue"),
  },
  {
    path: "/apps/invoice/edit/:id",
    name: "apps-invoice-edit",
    component: () =>
      import("@/views/apps/invoice/invoice-edit/InvoiceEdit.vue"),
  },
  {
    path: "/tabulation-sheet-print",
    name: "tabulation-sheet-print",
    component: () => import("@/views/myskool/tabulation/TabulationPrint.vue"),
    meta: {
      layout: "full",
      resource: "TabulationSheetMarks",
      proceed: true,
    },
  },
  {
    path: "/marksrecordprint",
    name: "marksrecordprint",
    component: () => import("@/views/myskool/exam/MarksRecordPrint.vue"),
    meta: {
      layout: "full",
      resource: "TabulationSheetMarks",
      proceed: true,
    },
  },
  {
    path: "/early-year-report",
    name: "early-year-report",
    component: () => import("@/views/myskool/exam/EarlyYearReport.vue"),
    meta: {
      layout: "full",
      resource: "TabulationSheetMarks",
      proceed: true,
    },
  },
  {
    path: "/early-year-report-whss",
    name: "early-year-report-whss",
    component: () => import("@/views/myskool/exam/EarlyYearReportWhss.vue"),
    meta: {
      layout: "full",
      resource: "TabulationSheetMarks",
      proceed: true,
    },
  },
  {
    path: "/farabi-result",
    name: "farabi-result",
    component: () => import("@/views/myskool/exam/FarabiResult.vue"),
    meta: {
      layout: "full",
      resource: "TabulationSheetMarks",
      proceed: true,
    },
  },
  {
    path: "/datesheet-print",
    name: "datesheet-print",
    component: () => import("@/views/myskool/exam/DatasheetPrint.vue"),
    meta: {
      layout: "full",
      resource: "TabulationSheetMarks",
      proceed: true,
    },
  },
  {
    path: "/staff-requests-print",
    name: "staff-requests-print",
    component: () => import("@/views/myskool/staff/StaffRequestsPrint.vue"),
    meta: {
      layout: "full",
      resource: "Auth",
      proceed: true,
    },
  },
  {
    path: "/student-ledger-print",
    name: "student-ledger-print",
    component: () => import("@/views/myskool/feestructure/LedgerPrint.vue"),
    meta: {
      layout: "full",
      resource: "Auth",
      proceed: true,
    },
  },
  {
    path: "/balance-sheet-print",
    name: "balance-sheet-print",
    component: () => import("@/views/myskool/accounts/BalanceSheetPrint.vue"),
    meta: {
      layout: "full",
      resource: "Auth",
      proceed: true,
    },
  },
  {
    path: "/audit-log-print",
    name: "audit-log-print",
    component: () => import("@/views/myskool/accounts/AuditLogPrint.vue"),
    meta: {
      layout: "full",
      resource: "Auth",
      proceed: true,
    },
  },
];
